import 'rxjs/add/operator/map';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

export class MongoResource<TQuery, TShort, TFull> {

  public headers: HttpHeaders;
  public baseUrl: string;

  constructor(public http: HttpClient) { }

  query(query?: any): Observable<TShort[]> {
    let params = new HttpParams();
    if (query) {
      Object.keys(query).forEach(k => {
        if ((<any>query)[k]) {
          params = params.append(k, (<any>query)[k]);
        }
      });
    }
    return this.http.get<TShort[]>(`${this.baseUrl}/`, { headers: this.headers, params: query });
  }

  get(_id: string): Observable<TFull> {
    return this.http.get<TFull>(`${this.baseUrl}/${_id}`, { headers: this.headers });
  }

  create(body: TFull): Observable<TFull> {
    return this.http.post<TFull>(`${this.baseUrl}/`, body, { headers: this.headers });
  }

  update(_id: string, body: TFull): Observable<TFull> {
    return this.http.post<TFull>(`${this.baseUrl}/${_id}`, body, { headers: this.headers });
  }

  remove(_id: string): Observable<TFull> {
    return this.http.delete<TFull>(`${this.baseUrl}/${_id}`, { headers: this.headers });
  }


  $get<TResult>(url: string, query?: HttpParams): Observable<TResult> {
    return this.http.get<TResult>(`${this.baseUrl}/${url}`, { headers: this.headers, params: query });
  }

  $post<TBody, TResult>(url: string, body?: TBody): Observable<TResult> {
    return this.http.post<TResult>(`${this.baseUrl}/${url}`, body, { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/shared/mongo.resource.ts